// @ts-nocheck
import PageLayout from '@components/PageLayout';
import PrescriptionPreview from '@components/my-prescriptions/PrescriptionPreview';
import { IMySavedPrescriptionsListPayload } from '@interfaces/myAppointmentInterfaces';
import { getMySavedPrescriptions, getPrescriptionDefault, setPrescriptionDefault, deletePrescriptionDefault } from '@services/myAppointmentServices';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation,  useNavigate } from 'react-router-dom';

import { RootState } from 'src/store/store';

import { getLabelFallback } from '@utils/utils';
import clsx from 'clsx';

import * as actions from '@redux-actions/';
import { PrescriptionProductCategory, INITIAL_PRESCRIPTIONS_DISPLAY_NUMBER } from '@utils/const';

import EyeWear from '@images/svg-icons/eyewearWhite.svg';
import ContactLenses from '@images/svg-icons/cl-white.svg';
import ContactLensesBlack from '@images/svg-icons/contactLensesBlack.svg'
import { GET_IN_STORE_PURCHASES_MY_PURCHASES_SUCCESS } from 'src/store/actions/actionTypes';

const MyPrescriptions = (): JSX.Element => {
    const dispatch = useDispatch();
    const location = useLocation();

    const config = useSelector((state: RootState) => state.common.config);
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const mySavedPrescriptions = useSelector(
        (state: RootState) => state.myAppointment.mySavedPrescriptions
    );

    const myPrescriptionsBackLabel = getLabelFallback('MY_APPOINTMENTS_MY_PRESCRIPTIONS_BACK_CTA_LABEL');
    const myPrescriptionsLabel = getLabelFallback('MYAPPOINTMENTS_MY_PRESCRIPTIONS_PAGE_TITLE');

    const navigate = useNavigate();

    const [loadedMorePrescriptions, setLoadedMorePrescriptions] = useState(false);
    const [hasOtherPrescriptions, setHasOtherPrescriptions] = useState(false);
    const [clToggleSelected, setClToggleSelected] = useState(
        location.state?.toggleClProp ? true : false
    );
    const [mixedScenario, setMixedScenario] = useState(false);
    const [numEye, setNumEye] = useState(0);
    const [numCL, setNumCL] = useState(0);
    const [numLoadMore, setNumLoadMore] = useState(0);
    const [idDefaultPrescriptionEyewear, setIdDefaultPrescriptionEyewear] = useState('');
    const [idDefaultPrescriptionContact, setIdDefaultPrescriptionContact] = useState('');

    useEffect(() => {
        // cleanup: when route changes and this component is destroyed remove the justUpdateId
        // in order to reset the green "just updated" text
        return () => {
            dispatch(actions.setJustUpdateId(''));
        };
    }, []);

    const renderPrescriptionPreviews = () => {
        const prescriptionsTypeToShow = clToggleSelected
            ? PrescriptionProductCategory.CONTACTS
            : PrescriptionProductCategory.GLASSES;
        const prescriptionsList = !!mySavedPrescriptions
            ? mySavedPrescriptions.filter(p =>
                  mixedScenario ? p.productCategory === prescriptionsTypeToShow : true
              )
            : [];
        const prescriptionsToShow = loadedMorePrescriptions
            ? prescriptionsList.length
            : INITIAL_PRESCRIPTIONS_DISPLAY_NUMBER;

        return prescriptionsList
            .slice(0, prescriptionsToShow)
            .map(p => (
                <PrescriptionPreview
                    key={p.prescriptionId}
                    firstName={p.firstName}
                    lastName={p.lastName}
                    lastUpdate={p.lastUpdate}
                    lastCreate={p.lastCreate}
                    expiration={p.expiration}
                    prescriptionName={p.prescriptionName}
                    prescriptionValue={p.prescriptionValue}
                    prism={p.prism}
                    prescriptionId={p.prescriptionId}
                    isContactLenses={p.productCategory === PrescriptionProductCategory.CONTACTS}
                    doctor={p.doctor}
                    clinic={p.clinic}
                    doctorAddress={p.doctorAddress}
                    fileName={p.fileName}
                    telephone={p.telephone}
                    leftCatentryId={p.leftCatentryId}
                    rightCatentryId={p.rightCatentryId}
                    leftCatentryParentId={p.leftCatentryParentId}
                    rightCatentryParentId={p.rightCatentryParentId}
                    prescriptionOriginMode={p.prescriptionOriginMode}
                    sameParent={p.sameparent}
                    brandCLLeft={p.brandCLLeft}
                    brandCLRight={p.brandCLRight}
                    rightPicture={p.rightPicture}
                    leftPicture={p.rightPicture}
                    nameCLRight={p.nameCLRight}
                    nameCLLeft={p.nameCLLeft}
                    partnumber={p.partnumber}
                    isPrescriptionDefault={p.prescriptionId.toString() === idDefaultPrescriptionEyewear || p.prescriptionId.toString() === idDefaultPrescriptionContact}
                    setSelectedPrescriptionAsDefault={selectDefaultPrescription}
                    deleteDefaultPrescription={deleteDefaultPrescription}
                    buyableCLRight={p.buyableCLRight}
                    buyableCLLeft={p.buyableCLLeft}
                    isPublishedCLLeft={p.isPublishedCLLeft}
                    isPublishedCLRight={p.isPublishedCLRight}
                />
            ));
    };

    const setIdDefaultPrescriptions = () => {
        getPrescriptionDefault(config.isMockRequest, config.storeId)
            .then((res: any) => {
                if (!!res) {
                    handleDefaultsPrescriptionSetted(res.preferredPrescription_glasses, res.preferredPrescription_contacts)
                } else {
                    console.error('>>> Error on retrieve right CL details');
                }
            })
            .catch(error => {
                console.error(
                    '>>> Error on retrieve prescription Default',
                    error.status,
                    ', error: ',
                    error
                );
            })
    }

    const handleDefaultsPrescriptionSetted = (resDefaultPrescriptionIdEye, resDefaultPrescriptionIdCl) => {
        // If there is no Default Prescription for eyewear, set the first that we use
        if(resDefaultPrescriptionIdEye.length === 0){
            const firstEyewearProduct = mySavedPrescriptions.find(eyewear => eyewear.productCategory === PrescriptionProductCategory.GLASSES);
            
            if(!!firstEyewearProduct){
                setPrescriptionDefault(config.storeId, 'add', PrescriptionProductCategory.GLASSES.toLowerCase(), firstEyewearProduct.prescriptionId.toString());
                setIdDefaultPrescriptionEyewear(firstEyewearProduct.prescriptionId.toString());
            }
        }else{
            setIdDefaultPrescriptionEyewear(resDefaultPrescriptionIdEye);
        }

        if(resDefaultPrescriptionIdCl.length === 0){
            const firstContactProduct = mySavedPrescriptions.find(contact => contact.productCategory === PrescriptionProductCategory.CONTACTS);
            
            if(!!firstContactProduct){
                setPrescriptionDefault(config.storeId, 'add', PrescriptionProductCategory.CONTACTS.toLowerCase(), firstContactProduct.prescriptionId.toString());
                setIdDefaultPrescriptionContact(firstContactProduct.prescriptionId.toString());
            }
        }else{
            setIdDefaultPrescriptionContact(resDefaultPrescriptionIdCl);
        }
    }

    const selectDefaultPrescription = (prescriptionId: string, isContactLensesSelected: boolean) => {
        const productCategorySelected = isContactLensesSelected ? 'contacts' : 'glasses';
        setPrescriptionDefault(config.storeId, 'add', productCategorySelected, prescriptionId)
        if(isContactLensesSelected){
            setIdDefaultPrescriptionContact(prescriptionId)
        }else{
            setIdDefaultPrescriptionEyewear(prescriptionId)
        }
    }

    const deleteDefaultPrescription = (prescriptionId: string, isContactLensesSelected: boolean) => {
        const productCategorySelected = isContactLensesSelected ? 'contacts' : 'glasses';
        deletePrescriptionDefault(config.storeId, 'remove', productCategorySelected, prescriptionId)
        if(isContactLensesSelected){
            setIdDefaultPrescriptionContact("");
        }else{
            setIdDefaultPrescriptionEyewear("");
        }
    }

    useEffect(() => {
        if (!!mySavedPrescriptions) {
            const eye = mySavedPrescriptions.filter(
                el => el.productCategory === PrescriptionProductCategory.GLASSES
            ).length;
            const contacts = mySavedPrescriptions.filter(
                el => el.productCategory === PrescriptionProductCategory.CONTACTS
            ).length;
            setNumCL(contacts);
            setNumEye(eye);
            setMixedScenario(eye !== 0 && contacts !== 0);
            // If i have both eyewear and contact i set load more according to switch (clToggleSelected) and set number for load more
            const mySavedPrescriptionsLength =
                eye === 0 || contacts === 0
                    ? Object.entries(mySavedPrescriptions).length
                    : clToggleSelected
                    ? contacts
                    : eye;
            setHasOtherPrescriptions(
                mySavedPrescriptionsLength > INITIAL_PRESCRIPTIONS_DISPLAY_NUMBER
            );
            setNumLoadMore(mySavedPrescriptionsLength);
            /*
                Setting First Prescription as Default if there are no def prescription 
                else recover default prescriptions e setting the id to have a match later when passing to PrescriptionPreview
            */
            setIdDefaultPrescriptions();
        }
    }, [mySavedPrescriptions]);

    useEffect(() => {
        if (!!mySavedPrescriptions && (numCL !== 0 || numEye !== 0)) {
            const mySavedPrescriptionsLength =
                numEye === 0 || numCL === 0
                    ? Object.entries(mySavedPrescriptions).length
                    : clToggleSelected
                    ? numCL
                    : numEye;
            setLoadedMorePrescriptions(false);
            setHasOtherPrescriptions(
                mySavedPrescriptionsLength > INITIAL_PRESCRIPTIONS_DISPLAY_NUMBER
            );
            setNumLoadMore(mySavedPrescriptionsLength);
        }
    }, [clToggleSelected]);

    const loadMoreClicked = () => {
        setLoadedMorePrescriptions(true);
        setHasOtherPrescriptions(false);
    };

    const navigateAddNewPrescription = () => {
        navigate(config.pagesUrl.myAppointments.addPrescriptionDefault);
    };

    const navigateAddNewPrescriptionEyewear = () => {
        navigate(config.pagesUrl.myAppointments.addPrescriptionForm);
    };

    return (
        <PageLayout
            data_element_id="AccountSummary_Static"
            hideMenu
            labelMenu={myPrescriptionsLabel}
            backLabel={myPrescriptionsBackLabel}
        >
            <div className="my-prescriptions">
                {!isMobile && (
                    <div className={`my-prescriptions-header ${!!mySavedPrescriptions && mySavedPrescriptions.length > 0 ? ' with-add-button' : ''} `}>
                        <div
                            role="region"
                            aria-label="my prescriptions page title"
                            className="primary-title"
                        >
                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_TITLE')}
                        </div>
                        {!!mySavedPrescriptions && mySavedPrescriptions.length > 0 && (
                            <div>
                                <button
                                    data-element-id="MyPrescription_AddPrescription"
                                    className="primary-button button-size-medium button-add-prescription"
                                    onClick={() => {
                                        (config.storeId === '12001' || config.storeId === 12001)
                                            ? navigateAddNewPrescription()
                                            : navigateAddNewPrescriptionEyewear();
                                    }}
                                    data-analytics_available_call="0"
                                >
                                    {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_BUTTON')}
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {isMobile && !!mySavedPrescriptions && mySavedPrescriptions.length > 0 && (
                    <div>
                        <button
                            data-element-id="MyPrescription_AddPrescription"
                            className="primary-button button-size-medium button-add-prescription"
                            onClick={() => {
                                (config.storeId === '12001' || config.storeId === 12001)
                                    ? navigateAddNewPrescription()
                                    : navigateAddNewPrescriptionEyewear();
                            }}
                            data-analytics_available_call="0"
                        >
                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_BUTTON')}
                        </button>
                    </div>
                )}

                {!!mySavedPrescriptions === false && (
                    <div
                    className="my-prescriptions-container content-container"
                    role="region"
                    aria-label="add new prescription"
                    >
                        <span className="no-prescriptions-saved">
                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_NO_PRESCRIPTION_SAVED')}
                            <br />
                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_NO_PRESCRIPTION_SAVED_2')}
                        </span>

                        <div>
                            <button
                                data-element-id="MyPrescriptions_AddNew"
                                className="primary-button button-size-medium button-add-prescription"
                                onClick={() => {
                                    (config.storeId === '12001' || config.storeId === 12001)
                                        ? navigateAddNewPrescription()
                                        : navigateAddNewPrescriptionEyewear();
                                }}
                                data-analytics_available_call="0"
                            >
                                {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_BUTTON')}
                            </button>
                        </div>
                    </div>
                )}

                {mixedScenario && (
                    <>
                        <div class="prescription-form-separator"></div>
                        <div className="add-prescription-default-container-button" role="navigation" aria-label="filter prescriptions type">
                            <div className="add-prescription-default-container-button-glasses">
                                <button
                                    className={clsx(
                                        'primary-button button-size-medium toggle eye',
                                        clToggleSelected && 'toggle-not-selected',
                                        !clToggleSelected && 'toggle-selected black'
                                    )}
                                    onClick={() => setClToggleSelected(false)}
                                    aria-label="show eyewear prescriptions"
                                >
                                    <EyeWear />
                                    {getLabelFallback(
                                        'MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_PRESCRIPTION_DEFAULT'
                                    )}
                                </button>
                            </div>
                            <div className="add-prescription-default-container-button-contact">
                                <button
                                    className={clsx(
                                        'primary-button button-size-medium toggle cl',
                                        clToggleSelected && 'toggle-selected black',
                                        !clToggleSelected && 'toggle-not-selected'
                                    )}
                                    onClick={() => setClToggleSelected(true)}
                                    aria-label="show contact lenses prescriptions"
                                >
                                    <ContactLensesBlack />
                                    {getLabelFallback(
                                        'MYPROFILE_MY_PRESCRIPTIONS_CL_PRESCRIPTION_DEFAULT'
                                    )}
                                </button>
                            </div>
                        </div>
                    </>
                )}

                {renderPrescriptionPreviews()}

                {/* Load more prescriptions button */}
                {hasOtherPrescriptions && !!mySavedPrescriptions && (
                    <div className="load-more-prescriptions-container">
                        <button
                            className="primary-button button-size-medium button-load-more-prescriptions"
                            onClick={loadMoreClicked}
                        >
                            LOAD MORE ({numLoadMore - INITIAL_PRESCRIPTIONS_DISPLAY_NUMBER})
                        </button>
                    </div>
                )}
            </div>
        </PageLayout>
    );
};

export default MyPrescriptions;
